'use strict';

module.exports = {
  FRAUDNET_LINK_JS: 'https://c.paypal.com/da/r/fb.js'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/data-collector/constants.js
// module id = 588
// module chunks = 0